import type { FieldConfigOverride } from "../types";

export const SOLE_PROP_KYB_OVERRIDE: FieldConfigOverride = {
	id: "any-sole-proprietorship-kyb-v1",
	// No incorporationCountry — applies to all countries
	entityType: "Sole Proprietorship",
	flowType: "KYB",
	version: "1.0.0",
	// Entity-only override — lower priority than country-level overrides
	priority: 10,

	fieldOverrides: {
		hasBoardOfDirectors: {
			visible: false,
		},
		ownershipTiers: {
			helpText: {
				en: "As a sole proprietor, you are typically the 100% owner. Add yourself as Tier 1.",
			},
		},
	},

	// Sole props: owner must always be disclosed regardless of percentage
	uboDisclosureThreshold: 100,
	ownershipDisclosureThreshold: 0,
};
